module.exports = __webpack_public_path__ + "img/logo.ed3aa7c3.svg";